import Toast from "./Toast";
import toast_reducer, { openToast, closeToast } from "./slice";

export { toast_reducer, openToast, closeToast };
export default Toast;
